/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".timeline-layer-select[_ngcontent-%COMP%]{display:block;height:20px;line-height:20px;padding:0 8px;margin-right:4px;border:none;float:left;border-radius:2px;font-size:10px;text-transform:uppercase;background:#77bcf0;color:#fff;cursor:pointer}.timeline-layer-select--active[_ngcontent-%COMP%]{background:#3d9fea}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-layer/timeline-layer-select/timeline-layer-select.component.styl.shim.ngstyle.js.pre-build-optimizer.js